import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export class ScrollEnter {
  constructor() {
    this.DOM = {};
    this.DOM.items = document.querySelectorAll('[data-inview]');
    this.DOM.totop = document.querySelector('[data-inview="totop"]');

    if (!this.DOM.items) return;

    this.init();
  }
  init() {

    this.DOM.items.forEach((item) => {
      const name = item.getAttribute('data-inview');
      let option = {
        trigger: item,
        start: 'top bottom-=25%',
        once: true,
        // markers: true,
        onEnter: () => item.classList.add('is-enter')
      };

      if( name === 'totop' ){
        option = {
          trigger: 'body',
          start: () => window.innerHeight,
          // markers: true,
          onEnter: () => this.DOM.totop.classList.add('is-show'),
          onLeaveBack: () => this.DOM.totop.classList.remove('is-show'),
        };
      }

      ScrollTrigger.create(option);
    });

  }
}
